export default __webpack_public_path__ + "static/media/py.560c70b6.svg";